export { default } from './StaticDropdownInputField';
